import { Preview } from 'react-dnd-multi-backend';
import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Spinner from '../../components/common/Spinner/Spinner';
import PageContent from '../../components/PageStructure/PageContent/PageContent';
import SidePanel from '../../components/PageStructure/SidePanel/SidePanel';
import PageHeader from '../../components/PageStructure/PageHeader/PageHeader';
import DragNDropContent from '../../components/DailyPlanning/DragNDropContent/DragNDropContent';
import TreatmentPanel from '../../containers/DailyPlanning/TreatmentPanel/TreatmentPanelContainer';
import Scheduler from '../../containers/DailyPlanning/Scheduler/SchedulerContainer';
import DailySidePanel from '../../containers/DailyPlanning/DailySidePanel/DailySidePanelContainer';
import DateSelector from '../../containers/DailyPlanning/DateSelector/DateSelectorContainer';
import Stats from '../../containers/DailyPlanning/Stats/StatsContainer';
import { appSettingsPropTypes, appSettingsDefault } from '../../propTypes/entities/appSettings';
import {
  RAGSTATUS_RED_FROMINTERVAL,
  RAGSTATUS_AMBER_FROMINTERVAL,
  SCHEDULER_DAYMODE_STARTTIME,
  SCHEDULER_NIGHTMODE_STARTTIME,
} from '../../settings/constants/appSettings';
import globals from '../../globals/communityGlobals';

const locale = globals.getArea('pageTitles');

class DailyPlanning extends React.Component {
  componentWillMount = () => {
    this.props.getAppSettings(SCHEDULER_DAYMODE_STARTTIME);
    this.props.getAppSettings(SCHEDULER_NIGHTMODE_STARTTIME);
    this.props.getAppSettings(RAGSTATUS_RED_FROMINTERVAL);
    this.props.getAppSettings(RAGSTATUS_AMBER_FROMINTERVAL);
  };

  componentDidMount = () => {
    this.props.getAllTeams(this.props.selectedDate);
    if (this.props.selectedTeam !== null) {
      this.props.getDailyPlanningDetails();
    }
  };

  componentWillReceiveProps = nextProps => {
    if (this.props.selectedTeam === null && nextProps.teams && nextProps.teams.length > 0) {
      this.props.setDefaultOrgUnitForDay(nextProps.teams[0].id);
    }
  };

  shouldComponentUpdate(nextProps) {
    return (
      this.props.selectedDate !== nextProps.selectedDate ||
      this.props.selectedTeam !== nextProps.selectedTeam ||
      this.props.teams.map(t => t.id).join(',') !== nextProps.teams.map(t => t.id).join(',')
    );
  }

  getPreviewStyle = (item, style) => (item.previewWidth ? { ...style, width: item.previewWidth } : style);

  generateDragNDropPreview = (type, item, style) => {
    /* eslint-disable react/no-danger */
    if (typeof item.previewHtml !== 'undefined') {
      return <div style={this.getPreviewStyle(item, style)} dangerouslySetInnerHTML={{ __html: item.previewHtml }} />;
    }
    /* enable-enable */
    return null;
  };
  render() {
    if (this.props.selectedTeam) {
      return (
        <PageContent {...this.props}>
          <div className="daily-planning-view">
            <SidePanel>
              <DailySidePanel />
            </SidePanel>
            <div className="flex-page-content content-wrapper">
              <PageHeader>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                  <div className="left-items">
                    {/* <label htmlFor="slide-menu" className="allocateIcons icon slider-label icon-side-open-close-left">
                  date_range
                </label> */}
                    <Typography variant="h3">{locale.getMsg('dailyPlanning')}</Typography>
                    <DateSelector />
                  </div>
                  <Stats />
                </div>
              </PageHeader>
              <DragNDropContent>
                <TreatmentPanel />
                <Scheduler appSettings={this.props.appSettings} />
                <Preview generator={this.generateDragNDropPreview} />
              </DragNDropContent>
            </div>
          </div>
        </PageContent>
      );
    }

    return <Spinner />;
  }
}

DailyPlanning.defaultProps = {
  selectedTeam: null,
  appSettings: appSettingsDefault,
};

DailyPlanning.propTypes = {
  selectedDate: PropTypes.string.isRequired,
  selectedTeam: PropTypes.number,
  setDefaultOrgUnitForDay: PropTypes.func.isRequired,
  getAppSettings: PropTypes.func.isRequired,
  appSettings: appSettingsPropTypes,
  getAllTeams: PropTypes.func.isRequired,
  getDailyPlanningDetails: PropTypes.func.isRequired,
  teams: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      isActive: PropTypes.bool.isRequired,
    }),
  ).isRequired,
};

export default DailyPlanning;
